import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import { fromEvent } from 'rxjs';
import { DOCUMENT } from '@angular/common';
class DotContextService {
  _document;
  _previousComponent;
  _outerClickSubscription;
  constructor(_document) {
    this._document = _document;
  }
  setOuterClickEvent() {
    if (this._outerClickSubscription) {
      return;
    }
    this._outerClickSubscription = fromEvent(this._document.body, 'click').subscribe(event => {
      if (event.target.closest('[data-context]')) {
        return;
      }
      if (this._previousComponent) {
        this.hide(this._previousComponent);
      }
    });
  }
  show(component) {
    const {
      _previousComponent
    } = this;
    if (_previousComponent && _previousComponent !== component) {
      _previousComponent.hide();
    }
    this._previousComponent = component;
    component.show();
    this.setOuterClickEvent();
  }
  hide(component) {
    this._previousComponent = null;
    component.hide();
    if (this._outerClickSubscription) {
      this._outerClickSubscription.unsubscribe();
      this._outerClickSubscription = null;
    }
  }
  static ɵfac = function DotContextService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotContextService)(i0.ɵɵinject(DOCUMENT));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotContextService,
    factory: DotContextService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotContextService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotContextService };
